const PHOTO = "https://images.unsplash.com/photo-1770860354782-1e6cda537ac6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

const EXAMPLE = "Cinematic night portrait of a young woman with long strawberry-blonde hair, wearing an oversized dark brown faux fur coat over light pink jeans, standing still with arms crossed loosely at her waist, calm detached gaze straight into the lens. Urban housing blocks behind her with scattered warm-lit windows, wet dark street, soft bokeh. Hard saturated red gel light from camera left sculpting her face against a cool teal-green ambient night, deep crushed shadows, high contrast. 35mm film look, visible grain, editorial fashion mood, medium shot, eye-level, 50mm lens, shallow depth of field, 4:5 aspect ratio.";

const STEPS = [
  ["Carica", "un'immagine o una breve clip video."],
  ["Scomponi", "soggetto, scena, stile, luce e camera in 6 sezioni."],
  ["Rigenera", "con il prompt pronto per Google Flow, Gemini, Nano Banana, Canva, Midjourney e altri."],
];

export const HomeShowcase = () => (
  <div className="rf-fade" data-testid="home-showcase">
    <div className="flex items-center gap-4 pb-6 border-b border-[var(--rf-ink)]">
      <h2 className="text-lg font-bold tracking-tight">Come funziona</h2>
      <span className="rf-mono text-[10px] tracking-[0.25em] uppercase text-[var(--rf-grey)]">Esempio reale</span>
    </div>
    <p className="py-8 text-base sm:text-lg leading-relaxed max-w-2xl" data-testid="home-explainer">
      Reverse Frame guarda un'immagine o un video come un direttore della fotografia e ti restituisce
      il <strong>prompt per ricrearlo</strong> con l'intelligenza artificiale. Utile per capire come è costruita una scena,
      rifare uno stile che ti piace o rieditare un contenuto.
    </p>
    <div className="grid grid-cols-12 gap-6 pb-10 border-b rf-line">
      <figure className="col-span-12 sm:col-span-5">
        <img src={PHOTO} alt="Ritratto notturno con luce rossa" className="w-full aspect-[4/5] object-cover" data-testid="home-example-image" />
        <figcaption className="rf-mono text-[10px] tracking-[0.2em] uppercase text-[var(--rf-grey)] pt-3">Input — foto</figcaption>
      </figure>
      <div className="col-span-12 sm:col-span-7 flex flex-col">
        <span className="text-5xl font-black tracking-tighter leading-none rf-red">06</span>
        <p className="mt-3 font-bold">Prompt Sintetico Ricostruito</p>
        <p className="mt-5 rf-mono text-[13px] leading-relaxed bg-[var(--rf-soft)] p-5 flex-1" data-testid="home-example-prompt">{EXAMPLE}</p>
        <p className="rf-mono text-[10px] tracking-[0.2em] uppercase text-[var(--rf-grey)] pt-3">Output — prompt</p>
      </div>
    </div>
    <ol className="grid sm:grid-cols-3 gap-6 pt-8" data-testid="home-steps">
      {STEPS.map(([t, d], i) => (
        <li key={t} className="border-t border-[var(--rf-ink)] pt-4">
          <span className="rf-mono text-xs rf-red">{String(i + 1).padStart(2, "0")}</span>
          <p className="font-bold mt-2">{t}</p>
          <p className="text-sm text-[var(--rf-grey)] mt-1 leading-relaxed">{d}</p>
        </li>
      ))}
    </ol>
  </div>
);
